import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import {
  listAttachmentByMessageId,
  queryAttachmentBySessionId,
} from "./thunkAction";

const initialState = {
  attachments: {},
  isLoadingListAttachmentByMessageId: false,
  errorListAttachmentByMessageId: null,
  isLoadingQueryAttachmentBySessionId: false,
  errorQueryAttachmentBySessionId: null,
};

const attachmentSlice = createSlice({
  name: "attachmentManage",
  initialState,
  reducers: {
    clearAttachment(state) {
      state.attachments = {};
    },
    resetListAttachmentByMessageIdError(state) {
      state.errorListAttachmentByMessageId = null;
    },
    resetQueryAttachmentBySessionIdError(state) {
      state.errorQueryAttachmentBySessionId = null;
    },
    setAttachments(state, action) {
      const attachments = _.get(action, "payload", []);
      const messageId = _.get(attachments, "0.messageId");
      if (messageId) {
        state.attachments[messageId] = attachments;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // listAttachmentByMessageId
      .addCase(listAttachmentByMessageId.pending, (state) => {
        state.isLoadingListAttachmentByMessageId = true;
      })
      .addCase(listAttachmentByMessageId.fulfilled, (state, action) => {
        state.errorListAttachmentByMessageId = null;
        state.isLoadingListAttachmentByMessageId = false;
        const attachments = _.get(action, "payload", []);
        const messageId = _.get(attachments, "0.messageId");
        if (messageId) {
          state.attachments[messageId] = attachments;
        }
      })
      .addCase(listAttachmentByMessageId.rejected, (state, action) => {
        state.isLoadingListAttachmentByMessageId = false;
        state.errorListAttachmentByMessageId = action.payload;
      })
      // queryAttachmentBySessionId
      .addCase(queryAttachmentBySessionId.pending, (state) => {
        state.isLoadingQueryAttachmentBySessionId = true;
      })
      .addCase(queryAttachmentBySessionId.fulfilled, (state, action) => {
        state.errorQueryAttachmentBySessionId = null;
        state.isLoadingQueryAttachmentBySessionId = false;
        const attachments = _.get(action, "payload", []);
        state.attachments = _.groupBy(attachments, "messageId");
      })
      .addCase(queryAttachmentBySessionId.rejected, (state, action) => {
        state.isLoadingQueryAttachmentBySessionId = false;
        state.errorQueryAttachmentBySessionId = action.payload;
      });
  },
});

export const attachmentReducer = attachmentSlice.reducer;

export const attachmentAction = attachmentSlice.actions;
